import ModalCart from "./ModalCart";

export default ModalCart;
